/**
 * lootdiff — pure hold-delta itemizer (Onda diving-polish).
 *
 * The wire carries NO per-dive loot event (S_GOODS just re-states the whole hold), so the client itemizes a
 * salvage haul by diffing the hold before/after the activity: snapshot the counts when the dive starts, diff
 * when the post-dive S_GOODS lands, present only the GAINS. Pure + allocation-light so it is unit-testable
 * and reusable by any future "bundle of loot" moment (dig payouts, raid hauls…). Zero wire, zero sim.
 */
import type { GoodsEntry } from '@piratas/protocol';

/** Snapshot a hold into an id → count map (the "before" side of a diff). */
export function holdCounts(hold: readonly GoodsEntry[]): Map<number, number> {
  const m = new Map<number, number>();
  for (const g of hold) m.set(g.id, g.count);
  return m;
}

/** Positive per-material deltas between a snapshot and the current hold (losses/no-ops are ignored). */
export function diffHoldGain(before: ReadonlyMap<number, number>, after: readonly GoodsEntry[]): { id: number; qty: number }[] {
  const out: { id: number; qty: number }[] = [];
  for (const g of after) {
    const gained = g.count - (before.get(g.id) ?? 0);
    if (gained > 0) out.push({ id: g.id, qty: gained });
  }
  return out;
}
